import ScheduleManagement from './ScheduleManagement.tsx'
import AddressManagement from './AddressManagement.tsx'

// Addresses render above meetings to match the setup order: a meeting needs an
// address (ScheduleManagement blocks submit without one).
const ClubMeetingsAdmin = () => (
  <div className="space-y-10">
    <AddressManagement />
    <ScheduleManagement />
  </div>
)

export default ClubMeetingsAdmin
